import { toast } from "react-hot-toast";

export const errorToast = text => {
  toast.error(text, {
    duration: 4000,
  });
};

export const successToast = text => {
  toast.success(text, {
    duration: 4000,
  });
};

export const infoToast = text => {
  toast(text, {
    icon: "ℹ",
    duration: 4000,
  });
};
